import { render, staticRenderFns } from "./AccessTabList.vue?vue&type=template&id=4383a196&"
import script from "./AccessTabList.vue?vue&type=script&lang=js&"
export * from "./AccessTabList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports